import styled from "styled-components";

export const RuleCard = styled.div`
  border: 1px solid rgba(130, 136, 148, 0.16);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  background: #fff;

  strong {
    color: var(--color-purple);
    font-weight: 500;
  }
`;

export const ProductDisplay = styled.div`
  padding: 12px 16px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #333;

  .product-sku {
    font-weight: 600;
    margin-right: 8px;
  }
`;

export const FormWrapper = styled.div`
  .field-holder {
    margin-bottom: 16px;
  }

  .checklist.invalid {
    border-color: #e74c3c;
  }

  textarea {
    font-family: var(--font-display);

    &::placeholder {
      font-family: var(--font-display);
    }
  }

  h2 {
    margin: 0;

    padding: 0;
    width: 100%;
    font-family: var(--font-display);
    font-style: normal;
    font-weight: normal;
    font-size: 1.25rem;
    line-height: 1.75rem;
    letter-spacing: 0.5px;
    color: var(--color-purple);
    margin-bottom: 20px;
  }
`;
